import utils from '@/utils/utils'
import { mapActions, mapState } from 'vuex'
import { LOGIN_TYPE } from '@/utils/constants'
import * as Sentry from '@sentry/browser'
export default {
  data () {
    return {
      activeName: 'CourseList',
      drawer: false,
      direction: 'ltr',
      down_list: false,
      isPhone: false,
      screenWidthBanner: document.documentElement.clientWidth,
      navText: '选课中心',
      webHref: '',
      JIANGSAI: process.env.VUE_APP_JIANGSAI
    }
  },
  mounted () {
    const _this = this
    _this.activeName = this.$route.name
    _this.screenWidthBanner = document.documentElement.clientWidth
    if (_this.screenWidthBanner < 767) {
      _this.isPhone = true
    } else {
      _this.isPhone = false
    }
    window.onresize = function () {
      _this.screenWidthBanner = document.documentElement.clientWidth
    }
  },
  created () {
    this.webHref = process.env.VUE_APP_ZHIXIN_URL
  },
  methods: {
    ...mapActions(['getUserInfo', 'logout']),
    // 判断屏幕大小
    checkPhone () {
      const width = document.body.clientWidth
      if (width < 767) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    handleClick (tab) {
      this.activeName = tab.name
      this.$router.push({ name: this.activeName, params: { target: 'click' } }).catch(_ => { })
      this.zhuGeEventTrack(this.zhugeEvents.HOME_PAGE.TAB_CLICK, [this.activeName === 'CourseList' ? '选课中心' : this.activeName === 'MyCoupon' ? '礼卷' : '讲座'])
    },
    goLogin () {
      this.zhuGeEventTrack(this.zhugeEvents.USER_ACTION.LOGIN_CLICK)
      this.$showLogin({ loginType: LOGIN_TYPE.LOGIN }, () => {
        this.getUserInfo().then(_ => {
        })
      })
    },
    visibleChange (flag) {
      this.down_list = flag
    },
    handleCommand (command) {
      if (command === 'order') {
        this.handleClick({ name: 'MyClass' })
      } else if (command === 'logout') {
        this.exitLogin()
      } else if (command === 'coupon') {
        this.handleClick({ name: 'MyCoupon' })
        // this.handleClick({ name: 'couponActivity' })
      } else if (command === 'vip') {
        this.handleClick({ name: 'VipCard' })
      } else if (command === 'protons') {
        this.handleClick({ name: 'Protons' })
      }
    },
    exitLogin () {
      this.logout().then(res => {
        if (res.data.code === 1) {
          this.$message.success('账号退出成功')
          location.reload()
        }
      })
      this.zhuGeEventTrack(this.zhugeEvents.USER_ACTION.LOG_OUT_CLICK)
    },
    // hover头像出现列表
    changeDownList () {
      this.down_list = !this.down_list
    },
    toCourseList () {
      if (this.$route.path !== '/') {
        this.$router.push({ name: 'CourseList' })
      }
    },
    findCategroy (e) {
      if (e.target.nodeName.toLowerCase() === 'li') {
        if (e.target.innerText === '选课中心') {
          this.drawer = false
          this.$router.push({ name: 'CourseList' })
        } else if (e.target.innerText === '讲座') {
          this.drawer = false
          this.$router.push({ name: 'Lecture' })
        }
      }
    },
    getPath () { // 监听路由
      // console.log(this.$route.name)
      if (this.$route.name === 'CourseList') {
        this.navText = '选课中心'
      } else if (this.$route.name === 'Lecture') {
        this.navText = '讲座'
      }
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin,
      userInfo: state => state.user.userInfo
    }),
    getMobileUrl () {
      if (utils.isAndroid()) {
        return 'https://sj.qq.com/myapp/detail.htm?apkName=com.eduzhixin.app'
      } else {
        return 'https://itunes.apple.com/cn/app/zhi-xin-zai-xian/id1157874179?mt=8'
      }
    }
  },
  watch: {
    isLogin () {
      if (this.isLogin) {
        Sentry.setUser({ id: this.userInfo.user_id })
      } else {
        Sentry.setUser({ id: 'unknow' })
      }
    },
    '$route' () {
      this.activeName = this.$route.name
    },
    screenWidthBanner () {
      this.checkPhone()
    },
    '$route.path': 'getPath'
  }
}
